export default "__VITE_ASSET__CY37pSyP__"